const LOGO_URL = "https://cdn2.f-cdn.com/contestentries/2426851/74260034/6689bc27dfb41_thumb900.jpg";

export { LOGO_URL };